<template>
  <div id="DunningRecordPopup_main">
    <el-dialog
      title="催繳紀錄"
      :visible.sync="dialogVisible"
      destroy-on-close
      width="50%"
      @closed="handleClosePopup"
    >
      <div class="tabletName">
        {{ tabletName }}
      </div>
      <el-table v-loading="loading" :data="dunningRecordList" style="width: 100%">
        <el-table-column type="index" label="#" width="55"></el-table-column>
        <el-table-column prop="CreateTime" label="催繳時間"></el-table-column>
        <el-table-column prop="ActorName" label="催繳人員"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { apiEvCharging } from '@/api/EvCharging'

export default {
  data () {
    return {
      dialogVisible: false,
      dunningItemList: [
        { label: '充電樁代碼', name: 'ConnectorSn' },
        { label: '充電樁位置', name: 'ConnectorName' },
        { label: '充電度數', name: 'ChargingKWH' },
        { label: '充電時間', name: 'ChargingDuration' },
        { label: '超時停車', name: 'IdleDuration' }
      ],
      dunningRecordList: [],
      tabletName: '',
      loading: false
    }
  },
  methods: {
    openDetailPopup (orderNumber) {
      this.dialogVisible = true
      this.getDetail(orderNumber)
    },
    getDetail (orderNumber) {
      if (!orderNumber) return
      this.loading = true
      apiEvCharging.Record.getDunningsRecord({ OrderNumber: orderNumber }).then(res => {
        if (res?.data?.Data) {
          this.dunningRecordList = res.data.Data.Dunnings
          this.tabletName = res.data.Data.TabletName || ''
        }
        this.loading = false
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    handleClosePopup () {
      this.chargingInfo = {}
      this.paymentRecord = {}
    }
  }
}
</script>
<style lang="scss" scoped>
#DunningRecordPopup_main {

  ::v-deep .el-dialog {
    @include basicDialog;
    min-width: 540px;
  }

  ::v-deep .el-table {
    @include basicTable;
  }

  .tabletName {
    text-align: start;
    color: $mainFontColor;
    font-size: map-get($fontSize, small);
    font-weight: 600;
    margin-bottom: 12px;
  }
}
</style>
